import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { SimpleApiResponse } from '../models/command-responses/simple-api-response.model';
import { UpdateNetworkCommandResponse } from '../models/command-responses/update-network-command-response.model';
import { GatewayDiscover } from '../models/gateway/gateway-discover.model';
import { GatewayNetworkConfigurationValue } from '../models/gateway/gateway-network-configuration-value.model';
import { GatewayNetworkConfiguration } from '../models/gateway/gateway-network-configuration.model';
import { ToroDeviceUpdateResponse } from '../models/toro-device-update-response.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class GatewayApiService extends ApiService
{

    constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    createGateway(accountId: number, locationId: number, uid: string, pin: number): Observable<ToroDeviceUpdateResponse>
    {
        const obj = {
            'AccountID': accountId,
            'UId': uid,
            'Pin': pin
        };
        return this.apiRequest(this.apiUrlService.getCreateGatewayUrl(locationId), this.HttpMethod.Post, JSON.stringify(obj));
    }

    updateGateway(gatewayId: number, locationId: number, uid: string, pin: number): Observable<ToroDeviceUpdateResponse>
    {
        const obj = {
            'UId': uid,
            'Pin': pin
        };
        return this.apiRequest(this.apiUrlService.getUpdateGatewayUrl(locationId, gatewayId), this.HttpMethod.Put, JSON.stringify(obj));
    }

    deleteGateway(gatewayId: number): Observable<ToroDeviceUpdateResponse>
    {
        return this.apiRequest(this.apiUrlService.getDeleteGatewayUrl(gatewayId), this.HttpMethod.Delete);
    }

    resyncGateway(gatewayId: number): Observable<ToroDeviceUpdateResponse>
    {
        return this.apiRequest(this.apiUrlService.getResyncGatewayUrl(gatewayId), this.HttpMethod.Post);
    }

    putGatewayInDiscoveryMode(gatewayId: number, accountId: number, locationId: number): Observable<GatewayDiscover>
    {
        return this.apiRequest(this.apiUrlService.getPutGatewayInDiscoveryModeUrl(gatewayId, accountId, locationId), this.HttpMethod.Post);
    }

    cancelGatewayDiscoveryMode(gatewayId: number)
    {
        return this.apiRequest(this.apiUrlService.getCancelGatewayDiscoveryModeUrl(gatewayId), this.HttpMethod.Post);
    }

    discoverGateway(replace: boolean, accountId: number, gatewayDiscover: GatewayDiscover): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getDiscoverGatewayUrl(replace, accountId), this.HttpMethod.Post, gatewayDiscover);
    }

    getGatewayNetworkConfiguration(gatewayId: number, refresh: boolean): Observable<GatewayNetworkConfiguration | SimpleApiResponse>
    {
        return this.apiRequest(this.apiUrlService.getGatewayNetworkConfigurationUrl(gatewayId, refresh), this.HttpMethod.Get)
            .pipe(
                map(response =>
                {
                    if (response['Success'])
                    {
                        return new SimpleApiResponse(response);
                    }

                    return new GatewayNetworkConfiguration(response);
                })
            );
    }

    updateGatewayNetworkConfiguration(gatewayId: number, networkConfigurationValue: GatewayNetworkConfigurationValue): Observable<UpdateNetworkCommandResponse>
    {
        return this.apiRequest(this.apiUrlService.getUpdateGatewayNetworkConfigurationUrl(gatewayId), this.HttpMethod.Post, networkConfigurationValue)
            .pipe(
                map((response: UpdateNetworkCommandResponse) =>
                {
                    return new UpdateNetworkCommandResponse(response);
                })
            );
    }

    wakeupGateway(gatewayId: number)
    {
        return this.apiRequest(this.apiUrlService.getWakeupUrl(gatewayId), this.HttpMethod.Put);
    }
}
